//#Global Imports
import { kycDocsId } from "../../utils";
import { Axios } from "../axios";
//#end Global Imports

//#Local Imports
import IKyc from "./kyc";
//#end Local Imports

export const uploadDocuments = async (body: FormData) => {
  const vendorUserKey = localStorage.getItem("vendorUserKey") || "";
  const currentUser = JSON.parse(localStorage.getItem("currentUser") || "{}");

  return await Axios.post(`/remit/users/${vendorUserKey}/senders/1/documents`, body, {
    headers: {
      Authorization: `${currentUser.idToken}`,
    },
  });
};

export const uploadDocumentsOffline = async (body: FormData) => {
  const vendorUserKey = localStorage.getItem("userKey") || "";
  const currentUser = JSON.parse(localStorage.getItem("currentUser") || "{}");

  return await Axios.post(`/remit/users/${vendorUserKey}/senders/1/documents`, body, {
    headers: {
      Authorization: `${currentUser.idToken}`,
    },
  });
};

export const eVerifyVoterIdCard = async (body: FormData) => {
  const vendorUserKey = localStorage.getItem("vendorUserKey") || "";
  const currentUser = JSON.parse(localStorage.getItem("currentUser") || "{}");

  return await Axios.post(
    `/remit/users/${vendorUserKey}/documents/${kycDocsId.E_VERIFY_VOTERID}/verifyVoterID`,
    body,
    {
      headers: {
        Authorization: `${currentUser.idToken}`,
      },
    }
  );
};

export const verifyVoterIdCardDocument = async (body: FormData) => {
  const vendorUserKey = localStorage.getItem("vendorUserKey") || "";
  const currentUser = JSON.parse(localStorage.getItem("currentUser") || "{}");

  return await Axios.post(
    `/remit/users/${vendorUserKey}/documents/${kycDocsId.VERIFY_VOTERID_DOC}/verifyDocument`,
    body,
    {
      headers: {
        Authorization: `${currentUser.idToken}`,
      },
    }
  );
};

export const eVerifyDL = async (body: FormData) => {
  const vendorUserKey = localStorage.getItem("vendorUserKey") || "";
  const currentUser = JSON.parse(localStorage.getItem("currentUser") || "{}");

  return await Axios.post(
    `/remit/users/${vendorUserKey}/documents/${kycDocsId.E_VERIFY_DL}/verifyDL`,
    body,
    {
      headers: {
        Authorization: `${currentUser.idToken}`,
      },
    }
  );
};

export const verifyDrivingLicenseDocument = async (body: FormData) => {
  const vendorUserKey = localStorage.getItem("vendorUserKey") || "";
  const currentUser = JSON.parse(localStorage.getItem("currentUser") || "{}");

  return await Axios.post(
    `/remit/users/${vendorUserKey}/documents/${kycDocsId.VERIFY_DL_DOC}/verifyDocument`,
    body,
    {
      headers: {
        Authorization: `${currentUser.idToken}`,
      },
    }
  );
};

export const eVerifyPan = async (body: FormData) => {
  const vendorUserKey = localStorage.getItem("vendorUserKey") || "";
  const currentUser = JSON.parse(localStorage.getItem("currentUser") || "{}");

  return await Axios.post(
    `/remit/users/${vendorUserKey}/documents/${kycDocsId.E_VERIFY_PAN}/verifyPan`,
    body,
    {
      headers: {
        Authorization: `${currentUser.idToken}`,
      },
    }
  );
};

export const eVerifyPanOffline = async (body: FormData) => {
  const vendorUserKey = localStorage.getItem("userKey") || "";
  const currentUser = JSON.parse(localStorage.getItem("currentUser") || "{}");

  return await Axios.post(
    `/remit/users/${vendorUserKey}/documents/${kycDocsId.E_VERIFY_PAN}/verifyPan`,
    body,
    {
      headers: {
        Authorization: `${currentUser.idToken}`,
      },
    }
  );
};

export const sendAadharOTP = async (body: IKyc.ISendAdharOtpProps) => {
  const currentUser = JSON.parse(localStorage.getItem("currentUser") || "{}");

  return await Axios.post(`/remit/users/aadhar/sendOtp`, body, {
    headers: {
      Authorization: `${currentUser.idToken}`,
    },
  });
};

export const validateAadharOTP = async (body: IKyc.IValidateAdharOtpProps) => {
  const currentUser = JSON.parse(localStorage.getItem("currentUser") || "{}");

  return await Axios.post(`/remit/users/aadhar/validateOtp`, body, {
    headers: {
      Authorization: `${currentUser.idToken}`,
    },
  });
};

export const verifyAadharCard = async (body: FormData) => {
  const vendorUserKey = localStorage.getItem("vendorUserKey") || "";
  const currentUser = JSON.parse(localStorage.getItem("currentUser") || "{}");

  return await Axios.post(
    `/remit/users/${vendorUserKey}/documents/${kycDocsId.VERIFY_AADHAR_CARD}/verifyDoc`,
    body,
    {
      headers: {
        Authorization: `${currentUser.idToken}`,
      },
    }
  );
};

export const verifyPassportFront = async (body: FormData) => {
  const vendorUserKey = localStorage.getItem("vendorUserKey") || "";
  const currentUser = JSON.parse(localStorage.getItem("currentUser") || "{}");

  return await Axios.post(
    `/remit/users/${vendorUserKey}/documents/${kycDocsId.PASSPORT_FRONT}/verifyDoc`,
    body,
    {
      headers: {
        Authorization: `${currentUser.idToken}`,
      },
    }
  );
};

export const verifyPassportBack = async (body: FormData) => {
  const vendorUserKey = localStorage.getItem("vendorUserKey") || "";
  const currentUser = JSON.parse(localStorage.getItem("currentUser") || "{}");

  return await Axios.post(
    `/remit/users/${vendorUserKey}/documents/${kycDocsId.PASSPORT_BACK}/verifyPassport`,
    body,
    {
      headers: {
        Authorization: `${currentUser.idToken}`,
      },
    }
  );
};

export const uploadAdditionalDocs = async ({ body, code, purpose }: IKyc.IUploadAdditionalDocs) => {
  const vendorUserKey = localStorage.getItem("vendorUserKey") || "";
  const currentUser = JSON.parse(localStorage.getItem("currentUser") || "{}");

  return await Axios.post(
    `/remit/user/${vendorUserKey}/lead/upload/doc?docType=${code}&purpose=${purpose}`,
    body,
    {
      headers: {
        Authorization: `${currentUser.idToken}`,
      },
    }
  );
};

export const getCkycStatus = async (ckycUserId: number) => {
  const currentUser = JSON.parse(localStorage.getItem("currentUser") || "{}");

  return await Axios.get(`/remit/kyc/ckyc/status/${ckycUserId}`, {
    headers: {
      Authorization: `${currentUser.idToken}`,
    },
  });
};

export const searchCkyc = async () => {
  const userRemitterId = localStorage.getItem("userRemitterId") || "";
  const currentUser = JSON.parse(localStorage.getItem("currentUser") || "{}");

  return await Axios.post(
    `/remit/kyc/ckyc/search/${userRemitterId}`,
    {},
    {
      headers: {
        Authorization: `${currentUser?.idToken}`,
      },
    }
  );
};

export const downloadCKYC = async (ckycNumber: string) => {
  const userRemitterId = localStorage.getItem("userRemitterId") || "";
  const currentUser = JSON.parse(localStorage.getItem("currentUser") || "{}");

  return await Axios.post(
    `/remit/kyc/ckyc/download/${userRemitterId}/ckycNumber/${ckycNumber}`,
    {},
    {
      headers: {
        Authorization: `${currentUser.idToken}`,
      },
    }
  );
};

export const sendCkycOtp = async (ckycNumber: string) => {
  const userRemitterId = localStorage.getItem("userRemitterId") || "";
  const currentUser = JSON.parse(localStorage.getItem("currentUser") || "{}");

  return await Axios.get(
    `remit/kyc/ckyc/sendMobileOtp/${userRemitterId}/ckycNumber/${ckycNumber}`,
    {
      headers: {
        Authorization: `${currentUser.idToken}`,
      },
    }
  );
};

export const validateCkycOtp = async (body: IKyc.IvalidateCkycOtpProps) => {
  const currentUser = JSON.parse(localStorage.getItem("currentUser") || "{}");

  return await Axios.post(`remit/kyc/ckyc/validateMobileOTP`, body, {
    headers: {
      Authorization: `${currentUser.idToken}`,
    },
  });
};

export const checkAndGetCkycDetails = async (ckycUserId: number) => {
  const currentUser = JSON.parse(localStorage.getItem("currentUser") || "{}");

  return await Axios.get(`/remit/kyc/ckyc/search/${ckycUserId}`, {
    headers: {
      Authorization: `${currentUser.idToken}`,
    },
  });
};

export const uploadAadharBack = async (body: FormData) => {
  const currentUser = JSON.parse(localStorage.getItem("vendorUserKey") || "{}");
  return await Axios.put(
    `/remit/users/${currentUser}/documents/${kycDocsId.UPLOAD_AADHAR_BACK}`,
    body,
    {
      headers: {
        Authorization: `${currentUser.idToken}`,
      },
    }
  );
};
